import React, { useEffect, useMemo, useState } from 'react';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';
import { Box, Typography } from '@mui/material';

const ORIENTATION_LOCK_PATHS = [
  '/checklist',
  '/camera/',
  '/process-images'
];

const isPortraitOrientation = () => {
  if (typeof window === 'undefined') return false;

  if (window.matchMedia) {
    return window.matchMedia('(orientation: portrait)').matches;
  }

  return window.innerHeight > window.innerWidth;
};

const requiresLandscape = (pathname = '') => {
  return ORIENTATION_LOCK_PATHS.some((path) => pathname.startsWith(path));
};

const overlayStyles = {
  position: 'fixed',
  inset: 0,
  zIndex: 2200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 3,
  py: 4,
  background: 'linear-gradient(180deg, rgba(7, 17, 34, 0.96) 0%, rgba(9, 28, 46, 0.98) 100%)',
  backdropFilter: 'blur(8px)'
};

const cardStyles = {
  width: '100%',
  maxWidth: 420,
  borderRadius: 4,
  px: 3,
  py: 4,
  textAlign: 'center',
  color: '#fff',
  border: '1px solid rgba(255,255,255,0.14)',
  backgroundColor: 'rgba(255,255,255,0.08)',
  boxShadow: '0 18px 54px rgba(0,0,0,0.28)'
};

const OrientationGuard = ({ pathname }) => {
  const [isPortrait, setIsPortrait] = useState(() => isPortraitOrientation());
  const shouldLockLandscape = useMemo(() => requiresLandscape(pathname), [pathname]);

  useEffect(() => {
    const updateOrientation = () => setIsPortrait(isPortraitOrientation());

    updateOrientation();
    window.addEventListener('resize', updateOrientation);
    window.addEventListener('orientationchange', updateOrientation);

    return () => {
      window.removeEventListener('resize', updateOrientation);
      window.removeEventListener('orientationchange', updateOrientation);
    };
  }, []);

  if (!shouldLockLandscape || !isPortrait) {
    return null;
  }

  return (
    <Box sx={overlayStyles}>
      <Box sx={cardStyles}>
        <ScreenRotationIcon sx={{ fontSize: 58, mb: 2, color: 'primary.main' }} />
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1.5 }}>
          Gira el dispositivo
        </Typography>
        <Typography sx={{ fontSize: '1rem', lineHeight: 1.5, opacity: 0.95 }}>
          Para continuar con el checklist, la camara y el procesado, debes usar el celular en horizontal.
        </Typography>
        <Typography sx={{ mt: 2, fontSize: '0.92rem', opacity: 0.74 }}>
          La pantalla inicial y el analisis general siguen disponibles en vertical.
        </Typography>
      </Box>
    </Box>
  );
};

export default OrientationGuard;
